import { Icon } from '@lounge-fe/ui-kit'

export const IconMap: Record<string, React.ReactNode> = {
  car: <Icon.Car />,
  medicine: <Icon.Medicine />,
  sun: <Icon.Sun />,
  users: <Icon.Users />,
  finance: <Icon.Finance />,
  beer: <Icon.Beer />,
  care: <Icon.Care />,
  shopping: <Icon.Shopping />,
  gift: <Icon.Gift className="w-6 h-6" />,
}
